import React, { useState, useEffect } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import "../styles/UtahAtAGlance.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBook,
  faBus,
  faLandmark,
  faUniversity,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import ActionButton from "../utils/ActionButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const library = "/img/library.png";

const libraryData = [
  {
    "Library Name": "Alta Reading Room",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "10351 E Hwy 210,Alta Community Center,Alta Utah",
    Zip: "84092-6001",
    Latitude: "40.577543",
    Longitude: "-111.833205",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "American Fork City Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "64 S 100 E,American Fork Utah",
    Zip: "84003-2326",
    Latitude: "40.375543",
    Longitude: "-111.796459",
    Website: "https://www.americanfork.gov/203/Library",
    Phone: "801-763-3070",
  },
  {
    "Library Name": "Anderson-Foothill Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake City Library System",
    Address: "1135 S 2100 E,Salt Lake City Utah",
    Zip: "84108-1912",
    Latitude: "40.744448",
    Longitude: "-111.830171",
    Website: "https://services.slcpl.org",
    Phone: "801-594-8611",
  },
  {
    "Library Name": "Beaver Public Library",
    "Library Type": "Public Library",
    "Library System": "Independent",
    Address: "55 W Center St,PO Box 192,Beaver Utah",
    Zip: "84713-0192",
    Latitude: "38.273966",
    Longitude: "-112.64225",
    Website: "https://beaverutah.net/community/library/",
    Phone: "435-438-5274",
  },
  {
    "Library Name": "Bingham Creek Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "4834 W 9000 S,West Jordan Utah",
    Zip: "84088-2213",
    Latitude: "40.588537",
    Longitude: "-112.006017",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Blanding Branch Library",
    "Library Type": "Public Library",
    "Library System": "San Juan County Library System",
    Address: "25 W 300 S,Blanding Utah",
    Zip: "84511",
    Latitude: "37.621125",
    Longitude: "-109.478419",
    Website: "https://sanjuancountyut.gov/libraries",
    Phone: "435 678-2335",
  },
  {
    "Library Name": "Bluff Branch Library",
    "Library Type": "Public Library",
    "Library System": "San Juan County Library System",
    Address: "480 Black Locust Ave,Bluff Utah",
    Zip: "84512",
    Latitude: "37.284378",
    Longitude: "-109.553677",
    Website: "https://sanjuancountyut.gov/libraries",
    Phone: "435-587-3818",
  },
  {
    "Library Name": "Bountiful Branch Library",
    "Library Type": "Public Library",
    "Library System": "Davis County Library System",
    Address: "725 S Main St,Bountiful Utah",
    Zip: "84010-6397",
    Latitude: "40.881941",
    Longitude: "-111.880153",
    Website: "http://www.co.davis.ut.us/library/",
    Phone: "801-451-1760",
  },
  {
    "Library Name": "Box Elder County Bookmobile",
    "Library Type": "Bookmobile",
    "Library System": "Box Elder County Library System",
    Address: "320 N. 1000 W., Bookmobile Building,PO Box 159,Tremonton Utah",
    Zip: "84337",
    Latitude: "41.715838",
    Longitude: "-112.181381",
    Website: "http://www.boxeldercounty.org/box-elder-county-bookmobile.htm",
    Phone: "435-695-2525",
  },
  {
    "Library Name": "Brigham City Public Library",
    "Library Type": "Public Library",
    "Library System": "Independent",
    Address: "26 East Forest Street,Bringham City Utah",
    Zip: "84302",
    Latitude: "41.510726",
    Longitude: "-112.014615",
    Website: "https://www.brighamlibrary.org/",
    Phone: "435-723-5850",
  },
  {
    "Library Name": "Cache County Library",
    "Library Type": "Public Library",
    "Library System": "Cache County Library System",
    Address: "15 N Main St,PO Box 63,Providence Utah",
    Zip: "84332",
    Latitude: "41.708392",
    Longitude: "-111.818124",
    Website: "https://www.cachecounty.org/library/",
    Phone: "435-752-7881",
  },
  {
    "Library Name": "Castle Dale Branch Library",
    "Library Type": "Public Library",
    "Library System": "Emery County Library System",
    Address: "135 N 100 E,PO Box 515,Castle Dale Utah",
    Zip: "84513",
    Latitude: "39.213685",
    Longitude: "-111.017833",
    Website: "http://lib.emerycounty.com/",
    Phone: "435-381-2554",
  },
  {
    "Library Name": "Castle Valley Library",
    "Library Type": "Public Library",
    "Library System": "Grand County Public Library System",
    Address: "2 Castle Valley Drive,Castle Valley Utah",
    Zip: "84532",
    Latitude: "38.651745",
    Longitude: "-109.424758",
    Website: "http://www.moablibrary.org",
    Phone: "435-259-9998",
  },
  {
    "Library Name": "Cedar City Public Library",
    "Library Type": "Public Library",
    "Library System": "Independent",
    Address: "303 N 100 E,Cedar City Utah",
    Zip: "84721-2610",
    Latitude: "37.682716",
    Longitude: "-113.06045",
    Website: "http://www.youseemore.com/CedarCity/default.asp",
    Phone: "435-586-6661",
  },
  {
    "Library Name": "Centerville Branch Library",
    "Library Type": "Public Library",
    "Library System": "Davis County Library System",
    Address: "45 S 400 W,Centerville Utah",
    Zip: "84014-2133",
    Latitude: "40.916835",
    Longitude: "-111.885103",
    Website: "http://www.co.davis.ut.us/library/",
    Phone: "801-451-1775",
  },
  {
    "Library Name": "Chapman Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake City Library System",
    Address: "577 S 900 W,Salt Lake City Utah",
    Zip: "84104-1302",
    Latitude: "40.756635",
    Longitude: "-111.916401",
    Website: "https://services.slcpl.org",
    Phone: "801-594-8623",
  },
  {
    "Library Name": "Clearfield Branch Library",
    "Library Type": "Public Library",
    "Library System": "Davis County Library System",
    Address: "1 N Main St,Clearfield Utah",
    Zip: "84015",
    Latitude: "41.114103",
    Longitude: "-112.026293",
    Website: "http://www.co.davis.ut.us/library/",
    Phone: "801-451-1840",
  },
  {
    "Library Name": "Cleone Peterson Eccles Library (Fairview)",
    "Library Type": "Public Library",
    "Library System": "North Sanpete Library (Independent/Academic)",
    Address: "75 S State,PO Box 315,Fairview Utah",
    Zip: "84629-0315",
    Latitude: "39.626832",
    Longitude: "-111.438956",
    Website: "https://bookmobiles.utah.gov/sanpete",
    Phone: "435-427-9305",
  },
  {
    "Library Name": "Cleveland Branch Library",
    "Library Type": "Public Library",
    "Library System": "Emery County Library System",
    Address: "45 W Main St,PO Box 275,Cleveland Utah",
    Zip: "84518-9999",
    Latitude: "39.348249",
    Longitude: "-110.852787",
    Website: "http://lib.emerycounty.com/",
    Phone: "435-653-2204",
  },
  {
    "Library Name": "Coalville Branch Library",
    "Library Type": "Public Library",
    "Library System": "Summit County Library System",
    Address: "82 N 50 E,Coalville Utah",
    Zip: "84017",
    Latitude: "40.919095",
    Longitude: "-111.398055",
    Website: "https://www.thesummitcountylibrary.org/",
    Phone: "435-336-3070",
  },
  {
    "Library Name": "Confederated Tribes of the Goshute Reservation Library",
    "Library Type": "Tribal Library",
    "Library System": "Tribal Library (Independent)",
    Address: "HC 61,PO Box 6104,Ibapah Utah",
    Zip: "84034",
    Latitude: "39.994758",
    Longitude: "-113.979557",
    Website: "https://ctgr.us/home/",
    Phone: "435-234-1138",
  },
  {
    "Library Name": "Daybreak Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "11358 Grandville Ave,South Jordan Utah",
    Zip: "84009",
    Latitude: "40.54478",
    Longitude: "-112.015276",
    Website: "https://services.slcpl.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Day-Riverside Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake City Library System",
    Address: "1575 W 1000 N,Salt Lake City Utah",
    Zip: "84116-1602",
    Latitude: "40.790515",
    Longitude: "-111.936022",
    Website: "https://services.slcpl.org",
    Phone: "801-594-8632",
  },
  {
    "Library Name": "Delta City Library",
    "Library Type": "Public Library",
    "Library System": "Independent",
    Address: "76 N 200 W,Delta Utah",
    Zip: "84624-9440",
    Latitude: "39.35359",
    Longitude: "-112.578698",
    Website: "https://sites.google.com/site/deltacitylibrary1/",
    Phone: "435-864-4945",
  },
  {
    "Library Name": "Draper Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "1136 E Pioneer Road,Draper Utah",
    Zip: "84020-9792",
    Latitude: "40.523004",
    Longitude: "-111.858439",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Duchesne Branch Library",
    "Library Type": "Public Library",
    "Library System": "Duchesne County Library System",
    Address: "130 S Center St, Ste A PO Box 169,Duchesne Utah",
    Zip: "84021-0169",
    Latitude: "40.162224",
    Longitude: "-110.401351",
    Website:
      "https://www.duchesne.utah.gov/your-government-2/county-departments/library/",
    Phone: "435-738-2800",
  },
  {
    "Library Name": "Dugway Post Library",
    "Library Type": "Special Library",
    "Library System": "U.S.Army Library System",
    Address: "5124 Kister Ave,1MWE-DUG-MWL MS3,Dugway Utah",
    Zip: "84022-5033",
    Latitude: "40.223148",
    Longitude: "-112.74612",
    Website: "https://dugway.armymwr.com/programs/library",
    Phone: "435-831-2179",
  },
  {
    "Library Name": "Eagle Mountain Public Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "1650 E Stagecoach Run,Eagle Mountain Utah",
    Zip: "84005-5350",
    Latitude: "40.309307",
    Longitude: "-112.012023",
    Website: "https://eaglemountain.gov/eagle-mountain-city-library/",
    Phone: "801-789-6623",
  },
  {
    "Library Name": "Elmo Branch Library",
    "Library Type": "Public Library",
    "Library System": "Emery County Library System",
    Address: "15 S 100 E,PO Box 217,Elmo Utah",
    Zip: "84521",
    Latitude: "39.391082",
    Longitude: "-110.819952",
    Website: "http://lib.emerycounty.com/",
    Phone: "435-384-2637",
  },
  {
    "Library Name": "Elsinore Town Library",
    "Library Type": "Public Library",
    "Library System": "Sevier County Library System",
    Address: "15 E 200 N,Elsinore Utah",
    Zip: "84724",
    Latitude: "38.686341",
    Longitude: "-112.148101",
    Website:
      "https://library.utah.gov/directory/listing/elsinore-town-library/",
    Phone: "435-527-4345",
  },
  {
    "Library Name": "Emery Branch Library",
    "Library Type": "Public Library",
    "Library System": "Emery County Library System",
    Address: "100 N Center St,PO Box 127,Emery Utah",
    Zip: "84522-9999",
    Latitude: "38.924629",
    Longitude: "-111.248631",
    Website: "http://lib.emerycounty.com/",
    Phone: "435-286-2474",
  },
  {
    "Library Name": "Enterprise Branch Library",
    "Library Type": "Public Library",
    "Library System": "Washington County Library System",
    Address: "393 S 200 E,PO Box 160,Enterprise Utah",
    Zip: "84725-0160",
    Latitude: "37.567046",
    Longitude: "-113.716405",
    Website: "http://library.washco.utah.gov/",
    Phone: "435-878-2574",
  },
  {
    "Library Name": "Ephraim Public Library",
    "Library Type": "Public Library",
    "Library System": "Ephraim City Library (Independent)",
    Address: "30 S Main St,Ephraim Utah",
    Zip: "84627-1310",
    Latitude: "39.359194",
    Longitude: "-111.587446",
    Website: "http://www.ephraimcity.org/155/Library",
    Phone: "435-283-4544",
  },
  {
    "Library Name": "Escalante Branch Library",
    "Library Type": "Public Library",
    "Library System": "Garfield County Library System",
    Address: "90 N 100 W,Escalante Utah",
    Zip: "84726-9999",
    Latitude: "37.771536",
    Longitude: "-111.601826",
    Website:
      "https://library.utah.gov/directory/listing/escalante-branch-library/",
    Phone: "435-826-4220",
  },
  {
    "Library Name": "Ferron Branch Library",
    "Library Type": "Public Library",
    "Library System": "Emery County Library System",
    Address: "55 N 200 W,PO Box 850,Ferron Utah",
    Zip: "84523-9999",
    Latitude: "39.090898",
    Longitude: "-111.13676",
    Website: "http://lib.emerycounty.com/",
    Phone: "435-384-2637",
  },
  {
    "Library Name": "Garden City Public Library",
    "Library Type": "Public Library",
    "Library System": "Rich County Library System",
    Address: "69 N Paradise Parkway, Bldg A,PO Box 348,Garden City Utah",
    Zip: "84028",
    Latitude: "41.948053",
    Longitude: "-111.40089",
    Website: "https://gardencityutlibrary.org/",
    Phone: "435-946-2950",
  },
  {
    "Library Name": "Garland Public Library",
    "Library Type": "Public Library",
    "Library System": "Garland City Library (Independent)",
    Address: "86 W Factory St,PO Box 129,Garland Utah",
    Zip: "84312-0129",
    Latitude: "41.741236",
    Longitude: "-112.163723",
    Website: "https://garland.lib.utah.gov",
    Phone: "435-257-3118 ",
  },
  {
    "Library Name": "Glendale Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake City Library System",
    Address: "1375 S Concord St,Salt Lake City Utah",
    Zip: "84104",
    Latitude: "40.739026",
    Longitude: "-111.926731",
    Website: "https://services.slcpl.org",
    Phone: "801-594-8660",
  },
  {
    "Library Name": "Grand County Public Library (Moab)",
    "Library Type": "Public Library",
    "Library System": "Grand County Public Library System",
    Address: "257 E Center St,Moab Utah",
    Zip: "84532",
    Latitude: "38.573628",
    Longitude: "-109.545562",
    Website: "http://www.moablibrary.org",
    Phone: "435-259-1111",
  },
  {
    "Library Name": "Grand County Public Library Teen Center",
    "Library Type": "Public Library",
    "Library System": "Grand County Public Library System",
    Address: "321 E Center Street,Moab Utah",
    Zip: "84532",
    Latitude: "38.57351",
    Longitude: "-109.54465",
    Website: "http://www.moablibrary.org",
    Phone: "435-259-1112",
  },
  {
    "Library Name": "Granite Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "3331 South 500 East,South Salt Lake Utah",
    Zip: "84106",
    Latitude: "40.699358",
    Longitude: "-111.875887",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Grantsville City Library",
    "Library Type": "Public Library",
    "Library System": "Tooele County Library System",
    Address: "42 N Bowery St,Grantsville Utah",
    Zip: "84029",
    Latitude: "40.600273",
    Longitude: "-112.446742",
    Website: "https://grantsvilleut.gov/departments/library/index.php",
    Phone: "435-884-1670",
  },
  {
    "Library Name": "Green River Branch Library",
    "Library Type": "Public Library",
    "Library System": "Emery County Library System",
    Address: "85 S Long St,PO Box 510,Green River Utah",
    Zip: "84525-9999",
    Latitude: "38.994388",
    Longitude: "-110.161933",
    Website: "http://lib.emerycounty.com/",
    Phone: "435-564-3349",
  },
  {
    "Library Name": "Gunnison Civic Library",
    "Library Type": "Public Library",
    "Library System": "Gunnison City Library (Independent)",
    Address: "38 W Center St,PO Box 790,Gunnison Utah",
    Zip: "84634-0790",
    Latitude: "39.155647",
    Longitude: "-111.819448",
    Website: "https://www.gunnisoncityutah.org/gunnison-civic-library",
    Phone: "435-528-3104",
  },
  {
    "Library Name": "Headquarters Library (Farmington)",
    "Library Type": "Public Library",
    "Library System": "Davis County Library System",
    Address: "133 S Main St,PO Box 115,Farmington Utah",
    Zip: "84025",
    Latitude: "40.978419",
    Longitude: "-111.887661",
    Website: "http://www.co.davis.ut.us/library/",
    Phone: "801-451-3030",
  },
  {
    "Library Name": "Helper City Library",
    "Library Type": "Public Library",
    "Library System": "Helper City Library (Independent)",
    Address: "19 S Main St,PO Box 221,Helper Utah",
    Zip: "84526-1533",
    Latitude: "39.687484",
    Longitude: "-110.85423",
    Website: "https://helpercitylibrary.wordpress.com/",
    Phone: "435-472-5601",
  },
  {
    "Library Name": "Herriman Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "5380 W Herriman Main St,Herriman Utah",
    Zip: "84096",
    Latitude: "40.516517",
    Longitude: "-112.018707",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Highland City Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "5400 W Civic Center Dr #2,Highland Utah",
    Zip: "84003",
    Latitude: "40.428176",
    Longitude: "-111.789117",
    Website: "https://www.highlandut.gov/1160/Library",
    Phone: "801-772-4528",
  },
  {
    "Library Name": "Hildale Branch",
    "Library Type": "Public Library",
    "Library System": "Washington County Library System",
    Address: "440 E Newel Ave,Hildale Utah",
    Zip: "84784",
    Latitude: "37.005472",
    Longitude: "-112.963515",
    Website: "http://library.washco.utah.gov/hildale/",
    Phone: "435-874-1341",
  },
  {
    "Library Name": "Holladay Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "2150 E Murray-Holladay Rd,Salt Lake City Utah",
    Zip: "84117-5241",
    Latitude: "40.66622",
    Longitude: "-111.828654",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Hunter Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "4740 W 4100 S,West Valley City Utah",
    Zip: "84120-4948",
    Latitude: "40.682718",
    Longitude: "-112.003908",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Huntington Branch Library",
    "Library Type": "Public Library",
    "Library System": "Emery County Library System",
    Address: "70 S Main St,PO Box 794,Huntington Utah",
    Zip: "84528-9999",
    Latitude: "39.325143",
    Longitude: "-110.964959",
    Website: "http://lib.emerycounty.com/",
    Phone: "435-687-9590",
  },
  {
    "Library Name": "Hurricane Branch Library",
    "Library Type": "Public Library",
    "Library System": "Washington County Library System",
    Address: "36 S 300 W,Hurricane Utah",
    Zip: "84737-2100",
    Latitude: "37.175691",
    Longitude: "-113.294256",
    Website: "http://library.washco.utah.gov/",
    Phone: "435-635-4621",
  },
  {
    "Library Name": "Hyrum Library",
    "Library Type": "Public Library",
    "Library System": "Hyrum City Library (Independent)",
    Address: "50 W Main St,Hyrum Utah",
    Zip: "84319-0310",
    Latitude: "41.634471",
    Longitude: "-111.85652",
    Website: "https://www.hyrumcity.org/library",
    Phone: "435-245-6411",
  },
  {
    "Library Name": "Iron County Bookmobile",
    "Library Type": "Bookmobile",
    "Library System": "Iron County Bookmobile (Under State Library Admin)",
    Address: "4763 N Santa Fe Trail,Enoch Utah",
    Zip: "84721-7455",
    Latitude: "37.763999",
    Longitude: "-113.043433",
    Website: "https://bookmobiles.utah.gov/iron",
    Phone: "801-505-8251",
  },
  {
    "Library Name": "Iron County Bookmobile Headquarters (Old School Library)",
    "Library Type": "Public Library",
    "Library System": "Iron County Bookmobile (State-run HQ)",
    Address: "4763 N Santa Fe Trail,Enoch Utah",
    Zip: "84721-9605",
    Latitude: "37.763999",
    Longitude: "-113.043433",
    Website: "https://bookmobiles.utah.gov/iron",
    Phone: "435-586-6715",
  },
  {
    "Library Name": "Kamas Branch",
    "Library Type": "Public Library",
    "Library System": "Summit County Library System",
    Address: "110 N Main St,Kamas Utah",
    Zip: "84036",
    Latitude: "40.640691",
    Longitude: "-111.285677",
    Website: "https://www.thesummitcountylibrary.org/",
    Phone: "435-783-3190",
  },
  {
    "Library Name": "Kanab City Library",
    "Library Type": "Public Library",
    "Library System": "Kanab City Library (Independent)",
    Address: "374 N Main St,Kanab Utah",
    Zip: "84741-3259",
    Latitude: "37.054348",
    Longitude: "-112.528161",
    Website: "http://www.kanablibrary.org/",
    Phone: "435-644-2394",
  },
  {
    "Library Name": "Kaysville Branch Library",
    "Library Type": "Public Library",
    "Library System": "Davis County Library System",
    Address: "215 N Fairfield Rd,Kaysville Utah",
    Zip: "84037-1949",
    Latitude: "41.062788",
    Longitude: "-111.946178",
    Website: "http://www.co.davis.ut.us/library/",
    Phone: "801-451-1800",
  },
  {
    "Library Name": "Kearns Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "5350 S 4220 W,Kearns Utah",
    Zip: "84118-4391",
    Latitude: "40.653782",
    Longitude: "-111.992424",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "La Sal Branch Library",
    "Library Type": "Public Library",
    "Library System": "San Juan County Library System",
    Address: "HWY 46 La Sal Community Center,PO Box 193,La Sal Utah",
    Zip: "84530",
    Latitude: "38.312766",
    Longitude: "-109.252056",
    Website: "https://sanjuancountyut.gov/libraries",
    Phone: "435-587-3819",
  },
  {
    "Library Name": "Law Library",
    "Library Type": "Special Library",
    "Library System": "Weber County Library System",
    Address: "2464 Jefferson Ave,Ogden Utah",
    Zip: "84401",
    Latitude: "41.221085",
    Longitude: "-111.964452",
    Website: "https://www.weberpl.lib.ut.us/",
    Phone: "801-337-2617",
  },
  {
    "Library Name": "Layton Branch Library",
    "Library Type": "Public Library",
    "Library System": "Davis County Library System",
    Address: "155 N Wasatch Dr,Layton Utah",
    Zip: "84041",
    Latitude: "41.062401",
    Longitude: "-111.961803",
    Website: "http://www.co.davis.ut.us/library/",
    Phone: "801-451-1820",
  },
  {
    "Library Name": "Lehi City Public Library (Temporary Location)",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "870 N. 100 E. Ste 110,Lehi Utah",
    Zip: "84043-1850",
    Latitude: "40.389313",
    Longitude: "-111.848579",
    Website: "https://www.lehi-ut.gov/recreation/library/",
    Phone: "385-201-1050",
  },
  {
    "Library Name": "Lewiston Public Library",
    "Library Type": "Public Library",
    "Library System": "Lewiston City Library (Independent)",
    Address: "33 S Main St,PO Box 36,Lewiston Utah",
    Zip: "84320-0036",
    Latitude: "41.975232",
    Longitude: "-111.856229",
    Website: "http://www.lewiston-ut.org/lewiston-library",
    Phone: "435-258-5515",
  },
  {
    "Library Name": "Logan Library",
    "Library Type": "Public Library",
    "Library System": "Logan City Library (Independent)",
    Address: "285 N Main,Logan Utah",
    Zip: "84321-6601",
    Latitude: "41.736416",
    Longitude: "-111.835519",
    Website: "http://library.loganutah.gov",
    Phone: "435-716-9130",
  },
  {
    "Library Name": "Magna Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "2675 S 8950 W,Magna Utah",
    Zip: "84044-1853",
    Latitude: "40.711285",
    Longitude: "-112.104287",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Main Branch (Salt Lake City Public Library)",
    "Library Type": "Public Library",
    "Library System": "Salt Lake City Library System",
    Address: "210 E 400 S,Salt Lake City Utah",
    Zip: "84111-2804",
    Latitude: "40.760082",
    Longitude: "-111.884841",
    Website: "https://services.slcpl.org",
    Phone: "801-524-8200",
  },
  {
    "Library Name": "Main Library (Ogden)",
    "Library Type": "Public Library",
    "Library System": "Weber County Library System",
    Address: "2464 Jefferson Ave,Ogden Utah",
    Zip: "84401-2404",
    Latitude: "41.221085",
    Longitude: "-111.964452",
    Website: "https://www.weberpl.lib.ut.us/",
    Phone: "801-337-2632",
  },
  {
    "Library Name": "Manti City Public Library",
    "Library Type": "Public Library",
    "Library System": "Manti City Library (Independent)",
    Address: "2 S Main St,Manti Utah",
    Zip: "84642-1349",
    Latitude: "39.265099",
    Longitude: "-111.637396",
    Website: "https://www.manticity.com/publiclibrary",
    Phone: "435-835-2201",
  },
  {
    "Library Name": "Marmalade Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake City Library System",
    Address: "280 W 500 N,Salt Lake City Utah",
    Zip: "84103",
    Latitude: "40.780526",
    Longitude: "-111.899181",
    Website: "https://services.slcpl.org",
    Phone: "801-594-8680",
  },
  {
    "Library Name": "Mendon Library",
    "Library Type": "Public Library",
    "Library System": "Cache County Library System",
    Address: "15 N Main St,Mendon Utah",
    Zip: "84325",
    Latitude: "41.708147",
    Longitude: "-111.976882",
    Website: "https://library.mendoncity.org/",
    Phone: "435-753-3449",
  },
  {
    "Library Name": "Milford Public Library",
    "Library Type": "Public Library",
    "Library System": "Milford City Library (Independent)",
    Address: "400 S 100 W,PO Box 69,Milford Utah",
    Zip: "84751",
    Latitude: "38.39625",
    Longitude: "-113.015734",
    Website: "http://www.milfordcityutah.com/index.php/1/library",
    Phone: "435-387-5039",
  },
  {
    "Library Name": "Millcreek Community Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "2266 E Evergeen Ave,Salt Lake City Utah",
    Zip: "84109-2998",
    Latitude: "40.69624",
    Longitude: "-111.826594",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Minersville Public Library",
    "Library Type": "Public Library",
    "Library System": "Beaver County Library System",
    Address: "40 W Main St,PO Box 250,Minersville Utah",
    Zip: "84752-0250",
    Latitude: "38.215699",
    Longitude: "-112.924701",
    Website: "https://townofminersville.municipalimpact.com/library",
    Phone: "435-386-2267",
  },
  {
    "Library Name": "Monroe Public Library",
    "Library Type": "Public Library",
    "Library System": "Sevier County Library System",
    Address: "55 N Main St,PO Box 120,Monroe Utah",
    Zip: "84754-0120",
    Latitude: "38.632771",
    Longitude: "-112.121792",
    Website: "https://monroecitylibrary.wordpress.com/",
    Phone: "435-527-4019",
  },
  {
    "Library Name": "Montezuma Creek Branch Library",
    "Library Type": "Public Library",
    "Library System": "San Juan County Library System",
    Address: "5th E St,Montezuma Creek Utah",
    Zip: "84534",
    Latitude: "37.261675",
    Longitude: "-109.299915",
    Website: "https://sanjuancountyut.gov/libraries",
    Phone: "435-651-3309",
  },
  {
    "Library Name": "Monticello Branch Library",
    "Library Type": "Public Library",
    "Library System": "San Juan County Library System",
    Address: "80 N Main St,PO Box 66,Monticello Utah",
    Zip: "84535-0066",
    Latitude: "37.873493",
    Longitude: "-109.342424",
    Website: "https://sanjuancountyut.gov/libraries",
    Phone: "435-587-2281",
  },
  {
    "Library Name": "Morgan County Library",
    "Library Type": "Public Library",
    "Library System": "Morgan County Library System",
    Address: "50 N 100 W,Morgan Utah",
    Zip: "84050-0600",
    Latitude: "41.037166",
    Longitude: "-111.679244",
    Website: "https://library.morgan-county.net/",
    Phone: "801 829-3481",
  },
  {
    "Library Name": "Mt. Pleasant Public Library",
    "Library Type": "Public Library",
    "Library System": "Mt. Pleasant City Library (Independent)",
    Address: "24 E Main St,Mt Pleasant Utah",
    Zip: "84647-1429",
    Latitude: "39.546516",
    Longitude: "-111.454672",
    Website: "http://mtpleasantlib.org",
    Phone: "435-462-3240",
  },
  {
    "Library Name": "Multi-County (Garfield/Kane) Bookmobile Library",
    "Library Type": "Bookmobile",
    "Library System": "Utah State Library Division (Bookmobile Program)",
    Address: "25 S 200 E,PO Box 805,Panguitch Utah",
    Zip: "84759",
    Latitude: "37.821232",
    Longitude: "-112.431704",
    Website: "https://bookmobiles.utah.gov/multi",
    Phone: "435-676-2431",
  },
  {
    "Library Name": "Murray Library",
    "Library Type": "Public Library",
    "Library System": "Murray City Library (Independent)",
    Address: "166 E 5300 S,Murray Utah",
    Zip: "84107-6075",
    Latitude: "40.655681",
    Longitude: "-111.886394",
    Website: "http://murraylibrary.org/",
    Phone: "801-264-2580",
  },
  {
    "Library Name": "Navajo Utah Commission Library",
    "Library Type": "Tribal Library",
    "Library System": "Tribal Library (Independent / Navajo Nation)",
    Address: "PO Box 570,Montezuma Creek Utah",
    Zip: "84534",
    Latitude: "37.260762",
    Longitude: "-109.308262",
    Website:
      "https://library.utah.gov/directory/listing/navajo-utah-commission-library/",
    Phone: "435-651-3508",
  },
  {
    "Library Name": "Nephi Public Library",
    "Library Type": "Public Library",
    "Library System": "Nephi City Library (Independent)",
    Address: "21 E 100 N,Nephi Utah",
    Zip: "84648-1501",
    Latitude: "39.710333",
    Longitude: "-111.835736",
    Website: "https://nephi.utah.gov/151/Public-Library",
    Phone: "435-623-1312",
  },
  {
    "Library Name": "New Harmony Branch Library",
    "Library Type": "Public Library",
    "Library System": "Washington County Library System",
    Address: "34 S 2900 E,New Harmony Utah",
    Zip: "84757-5155",
    Latitude: "37.481091",
    Longitude: "-113.242435",
    Website: "http://library.washco.utah.gov/new-harmony/",
    Phone: "435-867-0065",
  },
  {
    "Library Name": "Newton Town Library",
    "Library Type": "Public Library",
    "Library System": "Cache County Library System",
    Address: "51 S Center St,Newton Utah",
    Zip: "84327-0578",
    Latitude: "41.861269",
    Longitude: "-111.989103",
    Website: "http://www.newtontownlibrary.com/",
    Phone: "435-563-9283",
  },
  {
    "Library Name": "North Branch Library (Ogden)",
    "Library Type": "Public Library",
    "Library System": "Weber County Library System",
    Address: "475 E 2600 N,North Ogden Utah",
    Zip: "84414-2833",
    Latitude: "41.305194",
    Longitude: "-111.965529",
    Website: "https://www.weberpl.lib.ut.us/",
    Phone: "801-337-2650",
  },
  {
    "Library Name": "North Logan City Library",
    "Library Type": "Public Library",
    "Library System": "North Logan City Library (Independent)",
    Address: "475 E 2500 N,North Logan Utah",
    Zip: "84341-1523",
    Latitude: "41.778244",
    Longitude: "-111.820605",
    Website: "https://northloganlibrary.org/",
    Phone: "435-755-7169",
  },
  {
    "Library Name": "Northwestern Band of Shoshone Nation Library",
    "Library Type": "Tribal Library",
    "Library System": "Tribal Library (Independent / Shoshone Nation)",
    Address: "707 N Main St,Brigham City Utah",
    Zip: "84302",
    Latitude: "41.525052",
    Longitude: "-112.015919",
    Website: "http://nwbshoshone.com/",
    Phone: "435-734-2286",
  },
  {
    "Library Name": "Ogden Valley Branch Library",
    "Library Type": "Public Library",
    "Library System": "Weber County Library System",
    Address: "131 S 7400 E,Huntsville Utah",
    Zip: "84317-9800",
    Latitude: "41.261977",
    Longitude: "-111.770629",
    Website: "https://www.weberpl.lib.ut.us/",
    Phone: "801-337-2660",
  },
  {
    "Library Name": "Orangeville Branch Library",
    "Library Type": "Public Library",
    "Library System": "Emery County Library System",
    Address: "125 S Main St,PO Box 628,Orangeville Utah",
    Zip: "84537-9999",
    Latitude: "39.225888",
    Longitude: "-111.053141",
    Website: "http://lib.emerycounty.com/",
    Phone: "435-748-2726",
  },
  {
    "Library Name": "Orem Public Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "58 N State St,Orem Utah",
    Zip: "84057-5596",
    Latitude: "40.298606",
    Longitude: "-111.694688",
    Website: "https://library.orem.gov/",
    Phone: "801-229-7050",
  },
  {
    "Library Name": "Paiute Indian Tribe of Utah Library",
    "Library Type": "Tribal Library",
    "Library System": "Tribal Library (Independent / Paiute Indian Tribe)",
    Address: "440 N Paiute Drive,Cedar City Utah",
    Zip: "84721",
    Latitude: "37.685023",
    Longitude: "-113.057804",
    Website:
      "https://library.utah.gov/directory/listing/paiute-indian-tribe-of-utah-library/",
    Phone: "435-586-1112",
  },
  {
    "Library Name": "Panguitch City Library",
    "Library Type": "Public Library",
    "Library System": "Garfield County Library System",
    Address: "25 S 200 E, PO Box 75,Panguitch Utah",
    Zip: "84759-0075",
    Latitude: "37.821232",
    Longitude: "-112.431704",
    Website: "http://panguitchlibrary.org",
    Phone: "435-676-2431",
  },
  {
    "Library Name": "Park City Library",
    "Library Type": "Public Library",
    "Library System": "Park City Library (Independent)",
    Address: "1255 Park Ave,PO Box 668,Park City Utah",
    Zip: "84060",
    Latitude: "40.650728",
    Longitude: "-111.503199",
    Website: "https://parkcitylibrary.org/",
    Phone: "435-615-5601",
  },
  {
    "Library Name": "Parowan Public Library",
    "Library Type": "Public Library",
    "Library System": "Iron County Library System",
    Address: "16 S Main St PO Box 427,Parowan Utah",
    Zip: "84761-0427",
    Latitude: "37.841717",
    Longitude: "-112.828077",
    Website: "http://parowan.org/parowan-library/",
    Phone: "435-477-3491",
  },
  {
    "Library Name": "Payson City Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "66 S Main St,Payson Utah",
    Zip: "84651-2223",
    Latitude: "40.043023",
    Longitude: "-111.732591",
    Website: "https://paysonlibrary.org",
    Phone: "801-465-5220",
  },
  {
    "Library Name": "Pleasant Grove Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "30 E Center St,Pleasant Grove Utah",
    Zip: "84062-2234",
    Latitude: "40.363539",
    Longitude: "-111.739653",
    Website: "https://www.plgrove.org/library/",
    Phone: "801-785-3950",
  },
  {
    "Library Name": "Pleasant Valley Branch Library",
    "Library Type": "Public Library",
    "Library System": "Weber County Library System",
    Address: "5568 S Adams Ave Pkwy,Washington Terrace Utah",
    Zip: "84405",
    Latitude: "41.162534",
    Longitude: "-111.967978",
    Website: "https://www.weberpl.lib.ut.us/",
    Phone: "801-337-2690",
  },
  {
    "Library Name": "President Millard Fillmore Library",
    "Library Type": "Public Library",
    "Library System": "Millard County Library System",
    Address: "25 S 100 W,Fillmore Utah",
    Zip: "84631-5529",
    Latitude: "38.968307",
    Longitude: "-112.326113",
    Website: "http://www.fillmorelibrary.org/",
    Phone: "435-743-5314",
  },
  {
    "Library Name": "Price City Library",
    "Library Type": "Public Library",
    "Library System": "Price City Library (Independent)",
    Address: "159 E Main St,Price Utah",
    Zip: "84501",
    Latitude: "39.599958",
    Longitude: "-110.808046",
    Website: "https://www.pricecityutah.com/library.html",
    Phone: "435-636-3188",
  },
  {
    "Library Name": "Provo City Library at Academy Square",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "550 N University Ave,Provo Utah",
    Zip: "84601",
    Latitude: "40.241294",
    Longitude: "-111.658623",
    Website: "https://www.provolibrary.com/",
    Phone: "801-852-6650",
  },
  {
    "Library Name": "Rich County Library",
    "Library Type": "Public Library",
    "Library System": "Rich County Library System",
    Address: "21 N Main St,PO Box 44,Randolph Utah",
    Zip: "84064",
    Latitude: "41.665811",
    Longitude: "-111.185301",
    Website: "https://www.richcountyut.org/library/",
    Phone: "435-793-2122",
  },
  {
    "Library Name": "Richfield Public Library",
    "Library Type": "Public Library",
    "Library System": "Sevier County Library System",
    Address: "83 E Center St,Richfield Utah",
    Zip: "84701-2529",
    Latitude: "38.768209",
    Longitude: "-112.083209",
    Website: "https://www.richfieldlibrary.com/",
    Phone: "435-896-5169",
  },
  {
    "Library Name": "Richmond Public Library",
    "Library Type": "Public Library",
    "Library System": "Cache County Library System",
    Address: "38 W Main St PO Box 202,Richmond Utah",
    Zip: "84333-0202",
    Latitude: "41.92287",
    Longitude: "-111.809677",
    Website: "http://richmondlibrary.us",
    Phone: "435-258-5525",
  },
  {
    "Library Name": "Riverton Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "12877 S 1830 W,Riverton Utah",
    Zip: "84065-7026",
    Latitude: "40.517243",
    Longitude: "-111.940179",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Roosevelt Branch Library",
    "Library Type": "Public Library",
    "Library System": "Duchesne County Library System",
    Address: "70 W Lagoon St,Roosevelt Utah",
    Zip: "84066",
    Latitude: "40.299755",
    Longitude: "-109.992626",
    Website:
      "https://www.duchesne.utah.gov/your-government-2/county-departments/library/",
    Phone: "435-722-4441",
  },
  {
    "Library Name": "Ruth Vine Tyler Library (Midvale)",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "8041 S Wood St,Midvale Utah",
    Zip: "84047-7559",
    Latitude: "40.605021",
    Longitude: "-111.892675",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Salem City Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "59 S Main St,PO Box 901,Salem Utah",
    Zip: "84653",
    Latitude: "40.053673",
    Longitude: "-111.672884",
    Website: "http://library.salemcity.org/",
    Phone: "801-423-2622",
  },
  {
    "Library Name": "Salina Public Library",
    "Library Type": "Public Library",
    "Library System": "Sevier County Library System",
    Address: "90 W Main St,Salina Utah",
    Zip: "84654",
    Latitude: "38.957834",
    Longitude: "-111.861446",
    Website: "https://www.salinacity.org/library/",
    Phone: "435-529-7753",
  },
  {
    "Library Name": "Sandy Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "10100 S Petunia Way,Sandy Utah",
    Zip: "84092-3624",
    Latitude: "40.56775",
    Longitude: "-111.852197",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Sanpete/South Juab County Bookmobile",
    "Library Type": "Bookmobile",
    "Library System": "Utah State Library Division (Bookmobile Program)",
    Address: "75 S State,PO Box 315,Fairview Utah",
    Zip: "84629-0315",
    Latitude: "39.626832",
    Longitude: "-111.438956",
    Website: "https://bookmobiles.utah.gov/sanpete",
    Phone: "435-427-9305",
  },
  {
    "Library Name": "Santa Clara Branch Library",
    "Library Type": "Public Library",
    "Library System": "Washington County Library System",
    Address: "1099 N Lava Flow Dr,St George Utah",
    Zip: "84770-6718",
    Latitude: "37.127311",
    Longitude: "-113.636757",
    Website: "http://library.washco.utah.gov/",
    Phone: "435-986-0432",
  },
  {
    "Library Name": "Santaquin City Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "20 W 100 S,Santaquin Utah",
    Zip: "84655-8008",
    Latitude: "39.974293",
    Longitude: "-111.785626",
    Website: "https://www.santaquin.org/departments___services/library",
    Phone: "801-754-3030",
  },
  {
    "Library Name": "Saratoga Springs Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "1307 N Commerce Dr Suite 140,Saratoga Springs Utah",
    Zip: "84043",
    Latitude: "40.386358",
    Longitude: "-111.913042",
    Website: "http://www.saratogaspringscity.com/library",
    Phone: "801-766-6513",
  },
  {
    "Library Name": "Skull Valley Band of Goshute Indians",
    "Library Type": "Tribal Library",
    "Library System": "Tribal Library (Independent / Goshute Nation)",
    Address: "1198 N Main St,PO Box 448,Grantsville Utah",
    Zip: "84029",
    Latitude: "40.598802",
    Longitude: "-112.420919",
    Website: "https://indian.utah.gov/skull-valley-band-of-goshute/",
    Phone: "435-882-4872",
  },
  {
    "Library Name": "Smithfield Public Library",
    "Library Type": "Public Library",
    "Library System": "Cache County Library System",
    Address: "25 N Main St PO Box 35,Smithfield Utah",
    Zip: "84335-0035",
    Latitude: "41.837055",
    Longitude: "-111.833095",
    Website: "https://smithfieldutah.gov/library",
    Phone: "435-563-3555",
  },
  {
    "Library Name": "South Jordan Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "10673 S Redwood Road,South Jordan Utah",
    Zip: "84095",
    Latitude: "40.557285",
    Longitude: "-111.93656",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "South Main Clinic Reading Room",
    "Library Type": "Special Library",
    "Library System": "Salt Lake County Library Services",
    Address: "3690 S Main St,Salt Lake City Utah",
    Zip: "84115-4423",
    Latitude: "40.690578",
    Longitude: "-111.892118",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Southwest Branch Library",
    "Library Type": "Public Library",
    "Library System": "Weber County Library System",
    Address: "2039 W 4000 S,Roy Utah",
    Zip: "84067-2627",
    Latitude: "41.190692",
    Longitude: "-112.029289",
    Website: "https://www.weberpl.lib.ut.us/",
    Phone: "801-337-2617",
  },
  {
    "Library Name": "Spanish Fork Public Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "49 S Main St,Spanish Fork Utah",
    Zip: "84660-2030",
    Latitude: "40.109122",
    Longitude: "-111.654241",
    Website: "https://www.spanishfork.org/departments/library/",
    Phone: "801-804-4480",
  },
  {
    "Library Name": "Sprague Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake City Library System",
    Address: "2131 S 1100 E,Salt Lake City Utah",
    Zip: "84106",
    Latitude: "40.72458",
    Longitude: "-111.859346",
    Website: "https://services.slcpl.org",
    Phone: "801-594-8640",
  },
  {
    "Library Name": "Springdale Branch Library",
    "Library Type": "Public Library",
    "Library System": "Washington County Library System",
    Address: "126 Lion Blvd,PO Box 479,Springdale Utah",
    Zip: "84767-0479",
    Latitude: "37.19486",
    Longitude: "-112.998505",
    Website: "http://library.washco.utah.gov/",
    Phone: "435-772-3676",
  },
  {
    "Library Name": "Springville Public Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "45 S Main,Springville Utah",
    Zip: "84663-1358",
    Latitude: "40.166203",
    Longitude: "-111.610126",
    Website: "https://www.springville.org/library/",
    Phone: "801-489-2720",
  },
  {
    "Library Name": "St. George Branch Library",
    "Library Type": "Public Library",
    "Library System": "Washington County Library System",
    Address: "88 W 100 S,St George Utah",
    Zip: "84770-3405",
    Latitude: "37.10685",
    Longitude: "-113.585074",
    Website: "http://library.washco.utah.gov/",
    Phone: "435-634-5737",
  },
  {
    "Library Name": "Stansbury Park Library",
    "Library Type": "Public Library",
    "Library System": "Tooele County Library System",
    Address: "1 Country Club Dr,Stansbury Park Utah",
    Zip: "84074",
    Latitude: "40.645639",
    Longitude: "-112.295307",
    Website: "https://www.stansburypark.org/reading-room/",
    Phone: "435-882-6188",
  },
  {
    "Library Name": "Summit County Bookmobile",
    "Library Type": "Bookmobile",
    "Library System": "Summit County Library System",
    Address: "1885 W Ute Blvd #100,Park City Utah",
    Zip: "84098",
    Latitude: "40.723731",
    Longitude: "-111.546038",
    Website: "https://www.thesummitcountylibrary.org/",
    Phone: "435-615-3900",
  },
  {
    "Library Name": "Summit County Library (Kimball Junction)",
    "Library Type": "Public Library",
    "Library System": "Summit County Library System",
    Address: "1885 W Ute Blvd Ste 100,Park City Utah",
    Zip: "84098",
    Latitude: "40.723731",
    Longitude: "-111.546038",
    Website: "https://www.thesummitcountylibrary.org/",
    Phone: "435-615-3900",
  },
  {
    "Library Name": "Sweet Branch Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake City Library System",
    Address: "455 F St,Salt Lake City Utah",
    Zip: "84103-2851",
    Latitude: "40.779936",
    Longitude: "-111.876496",
    Website: "https://services.slcpl.org",
    Phone: "801-594-8651",
  },
  {
    "Library Name": "Syracuse Branch Library",
    "Library Type": "Public Library",
    "Library System": "Davis County Library System",
    Address: "1875 S 2000 W,Syracuse Utah",
    Zip: "84075-9359",
    Latitude: "41.086691",
    Longitude: "-112.064271",
    Website: "http://www.co.davis.ut.us/library/",
    Phone: "801-451-1850",
  },
  {
    "Library Name": "Taylorsville Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "4870 S 2700 W,Taylorsville Utah",
    Zip: "84118-2128",
    Latitude: "40.663466",
    Longitude: "-111.958597",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "Tooele City Public Library",
    "Library Type": "Public Library",
    "Library System": "Tooele County Library System",
    Address: "128 W Vine St,Tooele Utah",
    Zip: "84074-2059",
    Latitude: "40.530989",
    Longitude: "-112.302153",
    Website: "http://tooelecity.org/city-departments/library/",
    Phone: "435-882-2182",
  },
  {
    "Library Name": "Tremonton City Library",
    "Library Type": "Public Library",
    "Library System": "Tremonton City Library (Independent)",
    Address: "210 N Tremont St,Tremonton Utah",
    Zip: "84337-1215",
    Latitude: "41.714587",
    Longitude: "-112.165706",
    Website: "http://tremontonlibrary.org",
    Phone: "435-257-9525",
  },
  {
    "Library Name": "Tri-County Bookmobile",
    "Library Type": "Bookmobile",
    "Library System": "Utah State Library Division (Bookmobile Program)",
    Address: "79 N 100 W,PO Box 250,Bicknell Utah",
    Zip: "84715-0250",
    Latitude: "38.342069",
    Longitude: "-111.546024",
    Website: "https://bookmobiles.utah.gov/tri",
    Phone: "435-425-3170",
  },
  {
    "Library Name": "Tri-County Bookmobile Headquarters",
    "Library Type": "Public Library",
    "Library System": "Utah State Library Division (Bookmobile Program)",
    Address: "79 N 100 W,PO Box 250,Bicknell Utah",
    Zip: "84715-0250",
    Latitude: "38.342069",
    Longitude: "-111.546024",
    Website: "https://bookmobiles.utah.gov/tri",
    Phone: "435-425-3170",
  },
  {
    "Library Name": "Uintah County Library",
    "Library Type": "Public Library",
    "Library System": "Uintah County Library System",
    Address: "204 E 100 N,Vernal Utah",
    Zip: "84078-2695",
    Latitude: "40.456801",
    Longitude: "-109.525387",
    Website: "https://library.uintah.gov/",
    Phone: "435-789-0091",
  },
  {
    "Library Name": "Utah County Bookmobile Headquarters (Mapleton)",
    "Library Type": "Public Library",
    "Library System": "Utah State Library Division (Bookmobile Program)",
    Address: "125 W Community Center Way,Mapleton Utah",
    Zip: "84664",
    Latitude: "40.133588",
    Longitude: "-111.580096",
    Website: "https://bookmobiles.utah.gov/utah",
    Phone: "801-489-4833",
  },
  {
    "Library Name": "Utah County Bookmobile (Mapleton)",
    "Library Type": "Bookmobile",
    "Library System": "Utah State Library Division (Bookmobile Program)",
    Address: "125 W Community Center Way,Mapleton Utah",
    Zip: "84664",
    Latitude: "40.133588",
    Longitude: "-111.580096",
    Website: "https://bookmobiles.utah.gov/utah",
    Phone: "801-489-4833",
  },
  {
    "Library Name": "Ute Indian Tribe",
    "Library Type": "Tribal Library",
    "Library System": "Tribal Library (Independent / Ute Indian Tribe)",
    Address: "988 East 7500 South,PO Box 190,Fort Duchesne Utah",
    Zip: "84026",
    Latitude: "40.282204",
    Longitude: "-109.863224",
    Website: "https://library.utah.gov/directory/listing/ute-indian-tribe/",
    Phone: "435-725-4248",
  },
  {
    "Library Name": "Vineyard Children’s Library",
    "Library Type": "Public Library",
    "Library System": "Utah County Library System",
    Address: "125 S Main St,Vineyard UT",
    Zip: "84059",
    Latitude: "40.297158",
    Longitude: "-111.747771",
    Website: "https://www.facebook.com/Vineyardchildrenslibrary/",
    Phone: "801-226-1929",
  },
  {
    "Library Name": "Wasatch County Library",
    "Library Type": "Public Library",
    "Library System": "Wasatch County Library System",
    Address: "465 E 1200 S,Heber City Utah",
    Zip: "84032-3943",
    Latitude: "40.493944",
    Longitude: "-111.4055",
    Website: "http://wasatchlibrary.org",
    Phone: "435-654-1511",
  },
  {
    "Library Name": "Washington Branch Library",
    "Library Type": "Public Library",
    "Library System": "Washington County Library System",
    Address: "220 N 300 E,Washington Utah",
    Zip: "84780",
    Latitude: "37.134397",
    Longitude: "-113.504377",
    Website: "http://library.washco.utah.gov/",
    Phone: "435-627-2706",
  },
  {
    "Library Name": "West Jordan Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "8030 S 1825 W,West Jordan Utah",
    Zip: "84088-4025",
    Latitude: "40.605262",
    Longitude: "-111.942431",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "West Valley Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "2880 W 3650 S,West Valley City Utah",
    Zip: "84119-3753",
    Latitude: "40.693378",
    Longitude: "-111.961504",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
  {
    "Library Name": "White Mesa Ute Band Library",
    "Library Type": "Tribal Library",
    "Library System": "Tribal Library (Independent / White Mesa Ute Band)",
    Address: "33 Mesa View Dr.,PO Box 7096,White Mesa Utah",
    Zip: "84511",
    Latitude: "37.458201",
    Longitude: "-109.470472",
    Website: "https://library.utah.gov/directory/locations/white-mesa/",
    Phone: "435-678-3621",
  },
  {
    "Library Name": "Whitmore Library",
    "Library Type": "Public Library",
    "Library System": "Salt Lake County Library Services",
    Address: "2197 E Ft Union Blvd,Salt Lake City Utah",
    Zip: "84121-3139",
    Latitude: "40.624646",
    Longitude: "-111.828003",
    Website: "https://www.slcolibrary.org",
    Phone: "801-943-4636",
  },
];

const LibraryNew = () => {
  const [filteredLibraries, setFilteredLibraries] = useState(libraryData);
  const [filters, setFilters] = useState({
    name: "",
    type: "",
    system: "",
    zip: "",
  });

  // ✅ Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 12; // adjust as needed

  // Dropdown values
  const libraryTypes = [
    ...new Set(libraryData.map((lib) => lib["Library Type"])),
  ];
  const librarySystems = [
    ...new Set(libraryData.map((lib) => lib["Library System"])),
  ];

  // Apply filters
  useEffect(() => {
    const filtered = libraryData.filter((library) => {
      return (
        library["Library Name"]
          .toLowerCase()
          .includes(filters.name.toLowerCase()) &&
        library["Library Type"]
          .toLowerCase()
          .includes(filters.type.toLowerCase()) &&
        library["Library System"]
          .toLowerCase()
          .includes(filters.system.toLowerCase()) &&
        library["Zip"].toLowerCase().includes(filters.zip.toLowerCase())
      );
    });
    setFilteredLibraries(filtered);
    setCurrentPage(1); // reset page when filters change
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const resetFilters = () => {
    setFilters({ name: "", type: "", system: "", zip: "" });
  };

  const getLibraryIcon = (type) => {
    switch (type.toLowerCase()) {
      case "public library":
        return <img src={library} alt="library" className="w-10 h-10" />;
      case "bookmobile":
        return <FontAwesomeIcon icon={faBus} className="text-green-500" />;
      case "tribal library":
        return <FontAwesomeIcon icon={faLandmark} className="text-red-500" />;
      case "academic library":
        return (
          <FontAwesomeIcon icon={faUniversity} className="text-purple-500" />
        );
      default:
        return <FontAwesomeIcon icon={faBook} className="text-gray-500" />;
    }
  };

  const openGoogleMaps = (destLat, destLng) => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${destLat},${destLng}`;
    window.open(url, "_blank");
  };

  const LIBRARY_TYPE_COLORS = {
    "Public Library": "bg-blue-100 text-blue-800",
    Bookmobile: "bg-green-100 text-green-800",
    "Tribal Library": "bg-red-100 text-red-800",
    "Academic Library": "bg-purple-100 text-purple-800",
  };
  const DEFAULT_BADGE_COLOR = "bg-gray-100 text-gray-800";

  const typeCounts = filteredLibraries.reduce((acc, lib) => {
    const type = lib["Library Type"];
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});

  // ✅ Pagination logic
  const totalPages = Math.ceil(filteredLibraries.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = filteredLibraries.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-sky-50 to-white">
      <LandingSection
        data={{ imageName: "interior.webp", title: "Utah Libraries" }}
      />

      <div className="verticals_section">
        {" "}
        <div className="verticals-intro">
          {" "}
          <div className="verticals-intro-sec1">
            {" "}
            <h2>Utah's Libraries ({filteredLibraries.length})</h2>{" "}
          </div>{" "}
          <div className="verticals-intro-sec2">
            {" "}
            <p>
              {" "}
              Utah boasts a robust network of libraries serving communities
              across the state, offering resources, programs, and spaces for
              learning and connection.{" "}
            </p>{" "}
            <Link to={"/about"}>
              {" "}
              {/* <ActionButton data="Know More About Us" /> */}{" "}
            </Link>{" "}
          </div>{" "}
        </div>
      </div>

      {/* ✅ Filter Section (unchanged) */}
      <div className="p-8">
        <div className="bg-white rounded-lg shadow-md p-4 mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Library Name
              </label>
              <input
                type="text"
                name="name"
                value={filters.name}
                onChange={handleFilterChange}
                placeholder="Search by name"
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Library Type
              </label>
              <select
                name="type"
                value={filters.type}
                onChange={handleFilterChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="">All Types</option>
                {libraryTypes.map((type) => (
                  <option key={type} value={type}>
                    {type}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Library System
              </label>
              <select
                name="system"
                value={filters.system}
                onChange={handleFilterChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="">All Systems</option>
                {librarySystems.map((system) => (
                  <option key={system} value={system}>
                    {system}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Zip Code
              </label>
              <input
                type="text"
                name="zip"
                value={filters.zip}
                onChange={handleFilterChange}
                placeholder="Search by zip"
                className="w-full p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>
          <div className="flex justify-end mt-4">
            <button
              onClick={resetFilters}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition"
            >
              Reset Filters
            </button>
          </div>
        </div>
      </div>

      {Object.entries(typeCounts).length > 0 && (
        <div className="flex flex-wrap justify-center gap-3 mb-6">
          {Object.entries(typeCounts).map(([type, count]) => {
            const colorClass = LIBRARY_TYPE_COLORS[type] || DEFAULT_BADGE_COLOR;
            return (
              <span
                key={type}
                className={`text-sm font-medium px-3 py-1 rounded-full ${colorClass}`}
              >
                {type} ({count})
              </span>
            );
          })}
        </div>
      )}

      {/* ✅ Pagination Controls */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-4 mb-8 text-gray-700">
          {/* First Page */}
          <div
            onClick={() => setCurrentPage(1)}
            disabled={currentPage === 1}
            className={`px-2 py-1 rounded transition-transform duration-200 cursor-pointer
        ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-blue-600 hover:scale-110 hover:text-blue-800 active:scale-90"
        }`}
          >
            « First
          </div>

          {/* Previous Page */}
          <ArrowBackIcon
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            className={`cursor-pointer transition-transform duration-200
        ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-blue-600 hover:scale-110 hover:text-blue-800 active:scale-90"
        }`}
          />

          {/* Status */}
          <div className="text-lg sm:text-xl font-medium text-[#001f54] text-center">
            Showing {currentItems.length} of {filteredLibraries.length}{" "}
            libraries (Page {currentPage} of {totalPages})
          </div>

          {/* Next Page */}
          <ArrowForwardIcon
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            className={`cursor-pointer transition-transform duration-200
        ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-blue-600 hover:scale-110 hover:text-blue-800 active:scale-90"
        }`}
          />

          {/* Last Page */}
          <div
            onClick={() => setCurrentPage(totalPages)}
            disabled={currentPage === totalPages}
            className={`px-2 py-1 rounded transition-transform duration-200 cursor-pointer
        ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-blue-600 hover:scale-110 hover:text-blue-800 active:scale-90"
        }`}
          >
            Last »
          </div>
        </div>
      )}

      {/* ✅ Library Cards with Pagination */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-8">
        {currentItems.map((library, index) => (
          <div
            key={index}
            className="bg-white shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] rounded-xl hover:shadow-[0_8px_24px_0_rgba(1,76,178,0.3)] transition duration-300 hover:scale-105 transform group flex flex-col h-full"
          >
            <div className="p-5 flex flex-col h-full">
              <div className="flex-1">
                <div className="flex items-start">
                  <div className="text-2xl mr-3">
                    {getLibraryIcon(library["Library Type"])}
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-gray-800">
                      {library["Library Name"]}
                    </h2>
                    <span
                      className={`text-xs font-medium px-2 py-1 rounded-full ${
                        LIBRARY_TYPE_COLORS[library["Library Type"]] ||
                        DEFAULT_BADGE_COLOR
                      }`}
                    >
                      {library["Library Type"]}
                    </span>
                  </div>
                </div>
                <div className="mt-4 space-y-2">
                  <p className="text-gray-700">
                    <span className="font-semibold">System:</span>{" "}
                    {library["Library System"]}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">Address:</span>{" "}
                    {library.Address}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">Zip:</span> {library.Zip}
                  </p>
                  <p className="text-gray-700">
                    <span className="font-semibold">Phone:</span>{" "}
                    {library.Phone}
                  </p>
                  {library.Website && (
                    <p className="text-gray-700">
                      <span className="font-semibold">Website:</span>{" "}
                      <a
                        href={library.Website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-500 hover:underline"
                      >
                        Visit Website
                      </a>
                    </p>
                  )}
                </div>
              </div>
              <div className="mt-4">
                <div
                  onClick={() =>
                    openGoogleMaps(library.Latitude, library.Longitude)
                  }
                >
                  <ActionButton data="Get Directions" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <Footer />
    </div>
  );
};

export default LibraryNew;
